import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'

Vue.config.productionTip = false
Vue.prototype.$L = L

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
